import React, { type CSSProperties, type ReactNode } from "react";
import { cn } from "../utils/cn";

type ContainerProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

const Container = ({ children, className = "", style }: ContainerProps) => {
  return (
    <div className={cn("mx-auto w-full max-w-[1360px] px-4", className)} style={style}>
      {children}
    </div>
  );
};

export default Container;
